import { useCallback } from 'react';
import { useProjectMarkExportsSeenMutation } from '../types/graphqlTypes';
import { isShareMode } from '../share/shareMode';

/**
 * Mark-seen helper. Seen state is stored directly on the export document in the DB,
 * so reads come from `export.seen` on the project query (no client-side cache needed).
 *
 * The mutation returns the refreshed exports array, so Apollo will update any component
 * that reads `project.exports` automatically.
 */
export const useSeenExports = () => {
  const [markExportsSeenMutation] = useProjectMarkExportsSeenMutation();

  const markSeen = useCallback(
    (projectId: string, exportIds: string | string[]) => {
      const ids = Array.isArray(exportIds) ? exportIds : [exportIds];
      if (ids.length === 0) return;
      // A share-link visitor has no account to remember this for; the dot just clears locally.
      if (isShareMode()) return;
      markExportsSeenMutation({ variables: { projectId, exportIds: ids } }).catch((e) => console.error('Error marking exports as seen:', e));
    },
    [markExportsSeenMutation],
  );

  return { markSeen };
};
